/* eslint-disable */
export default function emptyFunction() {}
